export const palette = {
  white: '#ffffff',
  black: '#000000',

  gray05: '#111217',
  gray10: '#181b1f',
  gray15: '#22252b',
  gray20: '#2c2f35',
  gray25: '#383b42',
  gray30: '#44474e',
  gray35: '#51555b',
  gray40: '#5f6268',
  gray45: '#6e7177',
  gray50: '#7d8085',
  gray55: '#8c8f94',
  gray60: '#9c9fa3',
  gray65: '#ababaf',
  gray70: '#babcbe',
  gray75: '#c8cacc',
  gray80: '#d6d7d9',
  gray85: '#e1e2e3',
  gray90: '#ececed',
  gray95: '#f4f5f5',
  gray100: '#fbfbfb',

  blueDarkMain: '#3d71d9',
  blueDarkText: '#6e9fff',
  redDarkMain: '#d10e5c',
  redDarkText: '#ff5286',
  greenDarkMain: '#1a7f4b',
  greenDarkText: '#6ccf8e',
  orangeDarkMain: '#ff9900',
  orangeDarkText: '#fbad37',
  purpleDarkMain: '#C27AFF',
  purpleDarkText: '#D4A0FF',

  blueLightMain: '#3871dc',
  blueLightText: '#1f62e0',
  redLightMain: '#e0226e',
  redLightText: '#cf0e5B',
  greenLightMain: '#1b855e',
  greenLightText: '#0a764e',
  orangeLightMain: '#ff9900',
  orangeLightText: '#B04E0C',
  purpleLightMain: '#A24BC8',
  purpleLightText: '#7c2ea3',
};
